export enum ScrollElements {
  SELF = 'self',
  WINDOW = 'window',
  BODY = 'body',
}
